// Parameters
export const minPasswordCharacters = 16;

/**
 * Regex to validate whether the phone number format adheres
 * to the Australian style guidelines.
 * Reference: https://www.stylemanual.gov.au/grammar-punctuation-and-conventions/numbers-and-measurements/telephone-numbers
 */
export const phoneRegex = /^(0(?:\s*\d\s*){9}|13(?:\s*\d\s*){4})$/;

/**
 * Regex to validate whether the email format adheres to the required style guidelines.
 * Check if the email:
 * 1. Has one or more characters that can be letters (a-z, A-Z), digits (0-9), underscores (_), dots (.), plus signs (+), or hyphens (-).
 * 2. Has the at symbol.
 * 3. Has a domain name.
 * 4. Has a dot.
 * 5. Has a top level domain.
 */
export const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

/**
 * Regex to validate if the string has at least one uppercase letter
 */
export const haveUppercaseRegex = /(?=.*[A-Z])/;

/**
 * Regex to validate if the string has at least one lowercase letter
 */
export const haveLowercaseRegex = /(?=.*[a-z])/;

/**
 * Regex to validate if the string has is a date with the "DD-MM-YYYY" or the
 * "DD/MM/YYYY" format, where "DD" and "MM" can also be numbers of 1 digit 
 * (1-9) when the value < 10.
 */
export const dateDDMMYYYYRegex =
  /^([1-9]|0[1-9]|[12][0-9]|3[01])(-|\/)([1-9]|0[1-9]|1[0-2])(-|\/)(\d{4})$/;

/**
 * Regex to validate if the string has at least one digit
 */
export const haveDigitRegex = /(?=.*\d)/;

/**
 * Regex to define the minimum length of the string
 */
export const minimumCharactersRegex = new RegExp(
  `[A-Za-z\d@$!%*?&\-_]{${minPasswordCharacters},}`
);

// Regex expresions
export const passWordConditions = `The password must have at least ${minPasswordCharacters} characters, one uppercase letter, one lowercase letter, one number and one special character (@$!%*?&-_)`;
export const passWordRegex = new RegExp(
  `(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-_])[A-Za-z\d@$!%*?&\-_]{${minPasswordCharacters},}`
);
export const passWordRegexHookForm =
  /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&\-_])[A-Za-z\d@$!%*?&\-_]{10,}/;
